import React from 'react'

import AppBar from './AppBar'
import Links from './Links'

const Home = ({ links, me, children }) => (
  <header>
    <AppBar me={me} />
    <Links links={links} />
    {children}
  </header>
)

export default Home
